var map = {
	"./background-.png": 563,
	"./background-about.png": 3837,
	"./background-contact.png": 3802,
	"./background-education.png": 6382,
	"./background-menu.png": 6141,
	"./background-portfolio-console.png": 4431,
	"./background-portfolio-desktop.png": 1157,
	"./background-portfolio-mobile.png": 1212,
	"./background-portfolio-web.png": 638,
	"./background-portfolio.png": 6075,
	"./background-services.png": 5223,
	"./background-skills.png": 6630
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4225;